import React from 'react';
import { BarChart3, Image, Megaphone, Star } from 'lucide-react';
import { PremiumIcon } from '@radevents/shared';

/**
 * Die Bilder zu den Premium-Leistungen.
 *
 * Aus `lucide-react` statt handgezeichneter Pfade (01.09.2026): dieselben Pfade lagen vorher
 * doppelt im Code — im Premium-Dialog und in der Verkaufskarte — und jede Korrektur an einem
 * Strich musste man an beiden Stellen machen. Die Bibliothek zeichnet auf demselben 24er-Raster
 * mit 2px-Strich wie die uebrigen Symbole des Projekts, es aendert sich also nichts an der Optik.
 *
 * Welche Leistung welches Bild bekommt, entscheidet `PremiumIcon` in `shared/brand.ts` — die
 * Zuordnung steht hier, damit Web und App dieselbe Liste lesen und trotzdem ihre eigenen
 * Zeichensaetze verwenden koennen.
 */
const ICONS = { megaphone: Megaphone, chart: BarChart3, image: Image, star: Star } as const;

const PremiumBenefitIcon: React.FC<{ name: PremiumIcon; size?: number }> = ({ name, size = 18 }) => {
  const Glyph = ICONS[name];
  return <Glyph size={size} strokeWidth={1.7} aria-hidden />;
};

export default PremiumBenefitIcon;
